import { render, staticRenderFns } from "./EditSetPage.vue?vue&type=template&id=6e2d161d"
import script from "./EditSetPage.vue?vue&type=script&lang=js"
export * from "./EditSetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports